var _style, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDetailPageBgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 540,
    viewBox: "0 0 1512 540",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000131337581743546924740000015761667356397278850_);}\n\t.st1{fill:#DEF9FB;}\n\t.st2{clip-path:url(#SVGID_00000161605147239233637210000001310094324039202978_);}\n\t.st3{fill:none;stroke:#9AF0F7;stroke-width:17;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 326,
    width: 1512,
    height: 447
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100,
    cy: 374,
    r: 136
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 483,
    r: 136
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 583,
    cy: 492,
    r: 136
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 782,
    cy: 431,
    r: 136
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 903,
    cy: 534,
    r: 136
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1233,
    cy: 431,
    r: 136
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1410,
    cy: 374,
    r: 136
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1202,
    cy: 255,
    r: 72
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1058,
    cy: 438,
    r: 72
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 846,
    cy: 294,
    r: 72
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 516,
    cy: 359,
    r: 72
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 288,
    cy: 359,
    r: 72
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cy: 271,
    r: 72
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1512,
    cy: 271,
    r: 72
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 117,
    cy: 239,
    r: 63.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 342,
    cy: 428,
    r: 63.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 643,
    cy: 347,
    r: 63.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1024,
    cy: 374,
    r: 63.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1297,
    cy: 284,
    r: 63.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1399,
    cy: 110,
    r: 32.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1065,
    cy: 176,
    r: 32.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 715,
    cy: 224,
    r: 32.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 442,
    cy: 336,
    r: 32.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 301,
    cy: 167,
    r: 32.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailPageBgr);
export default __webpack_public_path__ + "static/media/detail-page-bgr.2283ac10c7db8323c04137da7b06563f.svg";
export { ForwardRef as ReactComponent };